export const pathNames = [
    {
        route: "dashboard",
        label: "داشبورد",
        description:
            "این بخش مربوط به داشبورد اصلی است و اطلاعات کلی را نمایش می‌دهد.",
        children: [],
    },
    {
        route: "profile",
        label: "پروفایل",
        description:
            "این بخش مربوط به داشبورد اصلی است و اطلاعات کلی را نمایش می‌دهد.",
        children: [],
    },
    {
        route: "ticket",
        label: "تیکت",
        description:
            "این بخش مربوط به داشبورد اصلی است و اطلاعات کلی را نمایش می‌دهد.",
        children: [],
    },
    {
        route: "recommended",
        label: "سهام پیشرو",
        description: `در این بخش به هر سهم بر اساس شاخص‌های از پیش تعریف شده امتیازی تعلق می‌گیرد که سهم‌ها بر اساس این امتیاز به ترتیب نزولی مرتب شده‌اند. این شاخص‌ها عبارتند از ورود پول حقیقی، قدرت خرید حقیقی، خرید درشت حقیقی، نسبت سفارش‌های خرید، نسبت سفارش‌های فروش، بازدهی سهم، تغییر ارزش معاملات سهم، تغییر ارزش معاملات اختیار خرید، تغییر ارزش معاملات اختیار فروش و درصد رشد یا افت قیمت در بازار کالای داخلی یا جهانی. هر کاربر می‌تواند بنابر اولویت‌های خود هر کدام از این شاخص‌ها را فعال یا غیرفعال کرده و وزن مشخصی را به آن‌ها نسبت دهد تا بر اساس اولویت‌ بندی خود به سهم مورد نظر برسد.`,
        children: [
            {
                route: "setting",
                label: "تنظیمات سهام پیشرو",
                description: "این یک متن آزمایشی است",
            },
        ],
    },
    {
        route: "market-watch",
        label: "تابلو خوانی",
        description: "این بخش اطلاعات کلی از تابلو خوانی بازار را نمایش می‌دهد.",
        children: [
            {
                route: "stocks",
                label: "تابلو سهام",
                description: "این بخش اطلاعات مرتبط با سهام مختلف را نمایش می‌دهد.",
                children: [
                    {
                        route: "money_flow",
                        label: "ورود پول حقیقی",
                        description: `در این بخش سهم‌ها بر اساس خالص خرید و فروش حقیقی  (مثبت = ورود پول، منفی = خروج پول) به ترتیب نزولی مرتب شده‌اند.`,
                    },
                    {
                        route: "buy_pressure",
                        label: "قدرت خرید حقیقی",
                        description: `در این بخش سهم‌ها بر اساس شاخص قدرت خرید حقیقی به ترتیب نزولی مرتب شده‌اند.`,
                    },
                    {
                        route: "buy_value",
                        label: "خرید درشت حقیقی",
                        description: `در این بخش سهم‌ها بر اساس میزان سرانه خرید حقیقی به ترتیب نزولی مرتب شده‌اند.`,
                    },
                    {
                        route: "buy_ratio",
                        label: "نسبت سفارش های خرید",
                        description: `این بخش برای هر سهم نشان می‌دهد که نسبت مجموع ارزش پنج سفارش اول خرید آن سهم به ارزش معاملات روز همان سهم چقدر است. در این بخش نیز سهم‌ها بر اساس این شاخص به ترتیب نزولی مرتب شده‌اند و درصد نسبت بیشتر نشان دهنده تمایل بیشتر سهامداران به خرید آن سهم و حمایت از آن است.`,
                    },
                    {
                        route: "sell_ratio",
                        label: "نسبت سفارش های فروش",
                        description: `این بخش برای هر سهم نشان می‌دهد که نسبت مجموع ارزش پنج سفارش اول فروش آن سهم به ارزش معاملات روز همان سهم چقدر است. در این بخش نیز سهم‌ها بر اساس این شاخص به ترتیب نزولی مرتب شده‌اند و درصد نسبت بیشتر نشان دهنده تمایل بیشتر سهامداران به فروش آن سهم است.`,
                    },
                    {
                        route: "value_change",
                        label: "ارزش معاملات",
                        description: `در این بخش ارزش معاملات روز هر سهم با میانگین ارزش معاملات یک ماه گذشته آن مقایسه شده است و سهم‌هایی که بیشترین افزایش ارزش معاملات را نسبت به میانگین یک ماهه خود داشته‌اند به ترتیب نزولی مرتب شده‌اند.`,
                    },
                ],
            },
            {
                route: "options",
                label: "تابلو آپشن",
                description: "متن آزمایشی",
                children: [
                    {
                        route: "call_value_change",
                        label: "ارزش آپشن های خرید",
                        description: "متن آزمایشی",
                    },
                    {
                        route: "put_value_change",
                        label: "ارزش آپشن های فروش",
                        description: "متن آزمایشی",
                    },
                    {
                        route: "option_price_spread",
                        label: "اسپرد قیمتی آپشن",
                        description: "متن آزمایشی",
                    },
                ],
            },
        ],
    },
    {
        route: "options",
        label: "آپشن ها",
        description: "",
        children: [
            {
                route: "strategies-no_risk",
                label: "استراتژی های بدون ریسک",
                description: "",
            },
            {
                route: "strategies-low_risk",
                label: "استراتژی های کم ریسک",
                description: "",
            },
            {
                route: "strategies-high_risk",
                label: "استراتژی های پر ریسک",
                description: "",
            },
            {
                route: "strategies",
                label: "استراتژی ها",
                description: "",
            },
        ],
    },
    {
        route: "domestic-market",
        label: "بازار داخلی",
        description: `در این بخش عملکرد تولید کننده‌ها و کالاهای مختلف در بورس کالای داخلی سنجیده شده است. این عملکرد‌ها در دو دسته اصلی «بیشترین افزایش» و «بیشترین کاهش» و برای دوره‌های هفتگی، ماهانه، سه ماهه، شش ماهه و سالانه ارائه شده‌اند.`,
        children: [
            {
                route: "top-price-changes",
                label: "بیشترین تغییرات قیمت کالا",
                description: "",
            },
            {
                route: "product-price-chart",
                label: "نمودار قیمتی کالا",
                description: "",
            },
            {
                route: "spread-price",
                label: "اسپرد قیمتی کالا",
                description: "",
            },
            {
                route: "monthly-stock-sales",
                label: "مبلغ فروش ماهانه کالا",
                description: "",
            },
        ],
    },
    {
        route: "global-market",
        label: "بازار جهانی",
        description: `در این بخش عملکرد کالاهای مختلف در بورس کالای جهانی سنجیده شده است. این عملکرد‌ها در دو دسته اصلی «بیشترین افزایش» و «بیشترین کاهش» و برای دوره‌های مختلف ارائه شده‌اند.`,
        children: [
            {
                route: "top-price-changes",
                label: "بیشترین تغییرات قیمت کالا",
                description: `در این بخش عملکرد کالاهای مختلف در بورس کالای جهانی سنجیده شده است. این عملکرد‌ها در دو دسته اصلی «بیشترین افزایش» و «بیشترین کاهش» و برای دوره‌های مختلف ارائه شده‌اند.`,
            },
            {
                route: "product-price-chart",
                label: "نمودار قیمتی کالا",
                description: "",
            },
            {
                route: "spread-price",
                label: "اسپرد قیمتی کالا",
                description: "",
            },
        ],
    },
    {
        route: "roi",
        label: "مقایسه بازدهی",
        description:
            "این بخش اطلاعات بازدهی سرمایه را برای سهم‌ها و صنایع مختلف نمایش می‌دهد.",
        children: [
            {
                route: "roi-stock",
                label: "بازدهی به تفکیک سهام",
                description: `در این بخش عملکرد روزانه، هفتگی، ماهانه، سه‌ ماهه، شش‌ ماهه، سالانه و سه ساله هر سهم آورده شده است و ترتیب پیش‌فرض سهم‌های ارائه شده بر اساس عملکرد سه‌ ماهه و به صورت صعودی است.`,
            },
            {
                route: "roi-industry",
                label: "بازدهی به تفکیک صنعت",
                description: `در این بخش عملکرد روزانه، هفتگی، ماهانه، سه‌ ماهه، شش‌ ماهه، سالانه و سه ساله هر صنعت آورده شده است و ترتیب پیش‌فرض سهم‌های ارائه شده بر اساس عملکرد سه‌ ماهه و به صورت صعودی است.`,
            },
            {
                route: "roi-personal-watch",
                label: "دیده‌بان شخصی",
                description: "",
            },
        ],
    },
    {
        route: "derivatives",
        label: "ابزارهای مشتقه بورس کالا",
        description: "",
        children: [
            {
                route: "commodity-market",
                label: "بورس کالا",
                description: "توضیحات: تست",
                children: [
                    {
                        route: "strategies",
                        label: "استراتژی بورس کالا",
                        description: "توضیحات: تست",
                    },
                    {
                        route: "future-contracts",
                        label: "قراردادهای آتی",
                        description: "توضیحات: تست",
                    },
                ],
            },
            {
                route: "stock-option",
                label: "آپشن سهام",
                description: "",
                children: [
                    {
                        route: "strategies",
                        label: "استراتژی آپشن سهام",
                        description: "توضیحات: تست",
                    },
                ],
            },
        ],
    },
];
